import React, { useEffect, useState } from "react";
import { useAuthContext } from "hooks/useAuthContext";
import { useAcademiYearContext } from "hooks/useAcademicYearContext";

// Material Dashboard 2 React components
// Icons
import EditAcademicYearPopup from "../components/editAcademicYearPopup";
import { API_URL } from "../../../../config";

export default function useData() {
  const { user } = useAuthContext();
  const { academicyears, dispatch } = useAcademiYearContext();
  const [loading, setLoading] = useState(true); // Add loading state

  //Fetch academicyears from the server
  useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        const response = await fetch(`${API_URL}/academicyears/getyears`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });

        const academicyearsjson = await response.json();

        if (response.ok) {
          dispatch({ type: "GET_ACADEMICYEARS", payload: academicyearsjson });
        }
        if (!response.ok) {
          throw new Error("Failed to fetch files");
        }
      } catch (error) {
        console.error("Error fetching files:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchAcademicYears();
    }
  }, [user, dispatch]);
  // Academic Years from Backend ends here

  if (loading) {
    return {
      columns: [],
      rows: [], // or handle loading state differently if you have a loading component
    };
  }
  return {
    columns: [
      { Header: "current", accessor: "current" },
      { Header: "year", accessor: "year", width: "70%" },
      { Header: "edit", accessor: "edit", align: "center" },
    ],

    rows: academicyears
      ? academicyears.map((item) => ({
          current: item.isCurrentAcademicYear ? "🟢" : "🔴",
          year: item.year,
          edit: <EditAcademicYearPopup academicyear={item} />,
        }))
      : [],
  };
}
